import { Range, Editor } from 'slate';
import { getCurrentListItems } from '../utils';
import ListDepthUtils from '../ListDepthUtils';
import type { EventHandler } from '../../../types/aha-editor';

const onBackspace: EventHandler<KeyboardEvent> = (event, ahaEditor) => {
  const { editor } = ahaEditor;

  if (!editor.selection || !Range.isCollapsed(editor.selection)) return;

  const currentListItems = getCurrentListItems(editor);
  if (currentListItems.length === 0) return undefined;

  const currentListItem = currentListItems.pop();
  if (!currentListItem) return undefined;

  const [listItem, path] = currentListItem;
  const isStart = Editor.isStart(editor, editor.selection.anchor, path);

  // When backspacing:
  // - any nested item: decrease depth
  // - other items: remove the list element so the item becomes a normal paragraph
  if (isStart) {
    event.preventDefault();

    ListDepthUtils.decreaseItemDepth(editor, [listItem, path], true);
  }
};

export default onBackspace;
